<template>
  <div class="razar" :class="monitoring ? '' : 'paused'">
    <div class="ringbase ring1"></div>
    <div class="ringbase ring2"></div>
    <div class="pulse"></div>
    <div class="pointer">
      <div></div>
    </div>
    <div class="dot pos1"></div>
    <div class="dot pos2"></div>
  </div>
</template>


<script>
    export default {
        props: ['monitoring'],
        mounted() {
           
        }
    }
</script>
